import * as React from 'react'

import { classList } from 'react-classlist-helper'

export function SidebarTitleColumn(props: {
  text: string
  bold: boolean
  isDisabled: boolean
  isBadgeShown: boolean
}) {
  return (
    <div
      className={classList({
        'tw:text-body-lg tw:text-foreground tw:mt-px tw:capitalize': true,
        'tw:opacity-[0.3]': props.isDisabled,
      })}
      style={{ flex: props.isBadgeShown ? 'none' : '1' }}
    >
      {props.text}
    </div>
  )
}

export function SidebarIconColumn(props: {
  isDisabled: boolean
  children: React.ReactNode
}) {
  return (
    <div
      className={classList({
        'tw:flex tw:items-center tw:[&>*]:flex-none tw:justify-start tw:pl-[18px]': true,
        'tw:opacity-[0.3]': props.isDisabled,
      })}
      style={{ flex: 'none', flexBasis: 55 }}
    >
      {props.children}
    </div>
  )
}

export function SidebarBadgeColumn(props: {
  isDisabled: boolean
  children: React.ReactNode
}) {
  return (
    <div
      className={classList({
        'tw:flex tw:items-center tw:[&>*]:flex-none tw:justify-center tw:ml-[5px]': true,
        'tw:opacity-[0.3]': props.isDisabled,
      })}
      style={{ flex: 'none' }}
    >
      {props.children}
    </div>
  )
}
